import { GridFilterModel, GridLinkOperator } from '@material-ui/data-grid'
import create from 'zustand'
import { persist } from 'zustand/middleware'

type MessageActions = {
  setFilter: (props: GridFilterModel) => void
  clearFilterUserSub: () => void
}

type State = GridFilterModel & MessageActions

const initialState: GridFilterModel = { items: [] }

export const useFilterSubGridUser = create<State>(
  persist(
    (set) => ({
      ...initialState,
      setFilter: (props: GridFilterModel) => {
        set({ ...props, linkOperator: GridLinkOperator.And })
      },
      clearFilterUserSub: () => {
        set({
          items: [],
        })
      },
    }),
    {
      name: 'filterUserGrid',
    },
  ),
)
